import * as React from 'react';
import { usePayment } from './PaymentContext';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Review({}) {
  const { cardNumber } = usePayment();
  const { cardName } = usePayment();
  const { email } = usePayment();
  const { expirationDate } = usePayment();

  const cardTypes = [
    {
      name: 'Visa',
      prefixes: ['4'],
      lengths: [13, 16],
    },
    {
      name: 'MasterCard',
      prefixes: ['51', '52', '53', '54', '55'],
      lengths: [16],
    },
    {
      name: 'American Express',
      prefixes: ['34', '37'],
      lengths: [15],
    },
    {
      name: 'Discover',
      prefixes: ['6011', '65', '644', '645', '646', '647', '648', '649'],
      lengths: [16],
    },
    {
      name: 'Diners Club',
      prefixes: ['36', '38', '39'],
      lengths: [14],
    },
    {
      name: 'JCB',
      prefixes: ['3528', '3589'],
      lengths: [16],
    },
    {
      name: 'UnionPay',
      prefixes: ['62'],
      lengths: [16, 17, 18, 19],
    },
  ];

  const getCardType = (number) => {
    // Remove all non-digit characters
    const cleanedNumber = number.replace(/\D/g, '');
    
    for (const card of cardTypes) {
      const { prefixes, lengths } = card;
  
      const startsWithPrefix = prefixes.some((prefix) => cleanedNumber.startsWith(prefix));
      const hasValidLength = lengths.includes(cleanedNumber.length);
  
      if (startsWithPrefix && hasValidLength) {
        return card.name; // Return the card name if a match is found
      }
    }
  
    return 'Unknown'; // Return 'Unknown' if no match found
  };

  const formatCardNumber = (number) => {
    const cleanedNumber = number.replace(/\D/g, ''); // Remove non-digit characters
    if (cleanedNumber.length < 4) return cleanedNumber; // Return as is if less than 4 digits
  
    const lastFourDigits = cleanedNumber.slice(-4); // Get last 4 digits
    const maskedDigits = '*'.repeat(cleanedNumber.length - 4); // Create a mask for the first digits
  
    return `${maskedDigits}${lastFourDigits}`; // Combine the masked and visible parts
  };

  const payments = [
    { name: 'Card type:', detail: getCardType(cardNumber) },
    { name: 'Card holder:', detail: cardName },
    { name: 'Email:', detail: email },
    { name: 'Card number:', detail: formatCardNumber(cardNumber) }, 
    { name: 'Expiry date:', detail: expirationDate },
  ];

  return (
    <Stack spacing={2}>
      <List disablePadding>
        <ListItem sx={{ py: 1, px: 0, fontFamily: 'math'}}>
          <ListItemText primary="MCB Dynamics" secondary="" />
          <Typography variant="body2">A$400.00</Typography>
        </ListItem>
        <ListItem sx={{ py: 1, px: 0, fontFamily: 'math' }}>
          <ListItemText primary="Tax" secondary="Free" />
          <Typography variant="body2">A$0.00</Typography>
        </ListItem>
        <ListItem sx={{ py: 1, px: 0, fontFamily: 'math' }}>
          <ListItemText sx={{fontFamily: 'math'}} primary="Total" />
          <Typography variant="subtitle1" sx={{ fontWeight: 700, fontFamily: 'math' }}>
            A$400.00
          </Typography>
        </ListItem>
      </List>
      <Divider />
      <Stack
        direction="column"
        divider={<Divider flexItem />}
        spacing={2}
        sx={{ my: 2, fontFamily: 'math' }}
      >
        <div>
          <Typography variant="subtitle2" gutterBottom>
            <h3>Payment details</h3>
          </Typography>
          <Grid container>
            {payments.map((payment) => (
              <React.Fragment key={payment.name}>
                <Stack
                  direction="row"
                  spacing={1}
                  useFlexGap
                  sx={{ width: '100%', mb: 1 }}
                >
                  <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                    {payment.name}
                  </Typography>
                  <Typography variant="body2">{payment.detail}</Typography>
                </Stack>
              </React.Fragment>
            ))}
          </Grid>
        </div>
      </Stack>
    </Stack>
  );
}
